module.exports = __webpack_public_path__ + "img/32-arab.6183a5fc.svg";